import React, { Component, Fragment } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

class CounterOne extends Component {
	state = {
		didViewCountUp: false,
	};
	onVisibilityChange = (isVisible) => {
		if (isVisible) {
			this.setState({ didViewCountUp: true });
		}
	};
	render() {
		let Data = [
			{
				countNum: 78,
				countTitle:
					"Porcentagem das pesquisas online em dispositivos móveis que resultam em compras offline. (Junto, 2019)",
			},
			{
				countNum: 51,
				countTitle:
					"Essa foi a porcentagem dos usuários de smartphones que descobriram novos negócios ou produtos enquanto faziam buscas no Google. (Google, 2018)",
			},
			{
				countNum: 34,
				countTitle:
					"Esses são os consumidores que estão propensos a realizar uma compra não planejada se a marca providenciar um conteúdo personalizado. (Forbes)",
			},
		];

		return (
			<Fragment>
				<div className="row">
					{Data.map((value, index) => (
						<div
							className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12"
							key={index}
						>
							<h5 className="counter">
								<VisibilitySensor
									onChange={this.onVisibilityChange}
									offset={{ top: 10 }}
									delayedCall
								>
									<CountUp
										end={this.state.didViewCountUp ? value.countNum : 0}
									/>
								</VisibilitySensor>
							</h5>
							<p className="description">{value.countTitle}</p>
						</div>
					))}
				</div>
			</Fragment>
		);
	}
}
export default CounterOne;
